import React from "react";
// import { render } from "react-dom";
import axios from 'axios';
import ReactDataGrid from "react-data-grid";
// import { Editors, Toolbar, Formatters } from 'react-data-grid-addons';
import update from 'immutability-helper';
import PopUpItem from './../PopUp/PopUpItem';
import { CSProduct } from './../_config.js'

require('./index.css');
require('./style.css');

var ScreenWidth = window.innerWidth;
// var ScreenHeigh = window.innerHeight;
// var rootWidth =  document.getElementById('root').style.width;
var Wcolumn = (ScreenWidth) - 33;

export default class App extends React.Component {

    constructor(props, context) {
        super(props, context);

        this._columns = [
            {
                key: 'col0',
                name: '',
                width: 33,
            },
            {
                key: 'col1',
                name: 'รหัสสินค้า',
                editable: true,
                resizable: true,
                width: Wcolumn * (10 / 100),
                filterable: true,
            },
            {
                key: 'col2',
                name: 'ชื่อสินค้า',
                editable: true,
                resizable: true,
                width: Wcolumn * (20 / 100)
            },
            {
                key: 'col3',
                name: 'นัดส่งมอบ',
                editable: true,
                resizable: true,
                width: Wcolumn * (5 / 100)
            },
            {
                key: 'col4',
                name: 'คลัง',
                editable: true,
                resizable: true,
                width: Wcolumn * (5 / 100)
            },
            {
                key: 'col5',
                name: 'ตำแหน่งเก็บ',
                editable: true,
                resizable: true,
                width: Wcolumn * (5 / 100)
            },
            {
                key: 'col6',
                name: 'หน่วย',
                editable: true,
                resizable: true,
                width: Wcolumn * (5 / 100)
            },
            {
                key: 'col7',
                name: 'ปริมาณ',
                editable: true,
                width: Wcolumn * (5 / 100)
            },
            {
                key: 'col8',
                name: 'ราคาขาย',
                editable: true,
                resizable: true,
                width: Wcolumn * (10 / 100)
            },
            {
                key: 'col9',
                name: 'ลด',
                editable: true,
                resizable: true,
                width: Wcolumn * (5 / 100)
            },
            {
                key: 'col10',
                name: 'จำนวนเงิน',
                editable: true,
                resizable: true,
                width: Wcolumn * (10 / 100)
            },
            {
                key: 'col11',
                name: 'อ้างอิง',
                editable: true,
                width: Wcolumn * (15 / 100)
            }
        ];

        this.state = {
            gdata: [],
            selectedIndexes: [],
            rows: this.createRows(this.props.HCenter / 30)
        };
    }


    createRows = (numberOfRows) => {
        let rows = [];
        for (let i = 0; i < numberOfRows; i++) {
            rows[i] = this.createData(i);
        }
        return rows;
    };

    createData = (index) => {
        return {
            col0: index + 1,
            col1: "", col2: "", col3: "", col4: "",
            col5: "", col6: "", col7: "", col8: "",
            col9: "", col10: "", col11: ""
        };
    };

    getColumns = () => {
        let clonedColumns = this._columns.slice();
        clonedColumns[0].events = {
            onClick: (ev, args) => {
                const idx = args.idx;
                const rowIdx = args.rowIdx;
                this.grid.openCellEditor(rowIdx, idx);
            }
        };
        return clonedColumns;
    };

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
        let rows = this.state.rows.slice();
        for (let i = fromRow; i <= toRow; i++) {
            let rowToUpdate = rows[i];
            let updatedRow = update(rowToUpdate, { $merge: updated });
            rows[i] = updatedRow;
        }
        this.setState({ rows });
    };

    getRowAt = (index) => {
        if (index < 0 || index > this.getSize()) {
            return undefined;
        }
        return this.state.rows[index];
    };

    getSize = () => {
        return this.state.rows.length;
    };

    state = {
        rowID: 0,
        columnID: 0,
    }

    onKeyDown = (event) => {
        var id1
        if (event.key === 'Enter' && this.state.columnID === 1) {
            id1 = event.target.value;
            this.onAdddata(id1);
        }
        if (this.state.columnID === 7) {
            id1 = event.target.value;
            var data = this.state.rows[this.state.rowID].col1;
            console.log(event.key + "*" + this.state.columnID + " // " + data);
            this.Test(data);
        }
        console.log(this.state.columnID);
    }
    Test = (data) => {
        this.onAdddata(data);
    }

    onKeyUp = (event) => {

    }

    getDate = () => {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd }
        if (mm < 10) { mm = '0' + mm }
        today = dd + '/' + mm + '/' + (yyyy + 543);
        return today;
    };

    onAdddata = (valIn1) => {
        var ItemCode = valIn1;
        if (valIn1) { ItemCode = valIn1 } else { ItemCode = this.state.rows[(this.state.rowID)].col1 }
        var Url = CSProduct(0, ItemCode);
        axios.get(Url).then(res => {
            let rows = [];
            for (let i = 0; i < this.state.rows.length; i++) {
                if (i === this.state.rowID && res.data.length !==0) {
                    var _col7 = this.state.rows[i].col7;
                    var _col9 = this.state.rows[i].col9;
                    if (!_col7) { _col7 = 1 }
                    if (!_col9) { _col9 = 0 }
                    rows[i] = {
                        col0: this.state.rows[i].col0,
                        col1: valIn1,
                        col2: res.data[0].NAMETH,
                        col3: this.getDate(),
                        col4: res.data[0].GRWAREHOUSE,
                        col5: res.data[0].GRLOCATION,
                        col6: res.data[0].STOCKUNIT,
                        col7: _col7,
                        col8: res.data[0].CAHSPRICE,
                        col9: _col9,
                        col10: (_col7 * res.data[0].CAHSPRICE) - _col9,
                        col11: this.state.rows[i].col11
                    }
                } else {
                    rows[i] = this.state.rows[i];
                }
            }
            this.setState({ rows: rows });
        });
    }

    onReturnData = (e) => {
        let rowsSent = [];
        var j = 0;
        setTimeout(() => {
            for (var i = 0; i < this.state.rows.length; i++) {
                if (this.state.rows[i].col1 !=='') {
                    rowsSent[j] = this.state.rows[i];
                    j++;
                }
            }
            this.props.ReturnValue_C(rowsSent);
            // console.log(rowsSent);
        }, 500);
    }

    onCellSelected = ({ rowIdx, idx }) => {
        this.setState({ rowID: rowIdx, columnID: idx });
    };

    Get_PopUpItem = (data) => {
        for (let i = 0; i < this.state.rows.length; i++) {
            if (this.state.rows[i].col1 === '') {
                this.setState({ rowID: i, columnID: 0 });
                this.onAdddata(data);
                this.onReturnData();
                break;
            }
        }
        this.onAdddata(data);
        this.setState({ showPopup: !this.state.showPopup });
    }

    togglePopup(value) {
        this.setState({ showPopup: !this.state.showPopup });
    }

    getCellActions(column, row) {
        if (column.key === 'col0' && row.col0 === sessionStorage.getItem("centerSearchBTN")) {
            return [{
                icon: 'fas fa-search',
                callback: () => { sessionStorage.setItem("centerSes", Date.now()) }
            },
            ];
        }
    }

    componentDidMount() {
        setInterval(() => {
            var CHa = sessionStorage.getItem("centerSes");
            var TCa = Date.now() - 100
            if (CHa >= TCa) {
                this.togglePopup();
            }
            for (let i = 0; i < this.state.rows.length; i++) {
                if (this.state.rows[i].col1 === "") {
                    sessionStorage.setItem("centerSearchBTN", i + 1);
                    this.setState({ numRow: 1 })
                    break;
                }
            }
        }, 100);
    }

    render() {
        return (
            <div class="container" style={{ minHeight: this.props.HFooter, minWidth: this.props.WContent, marginTop: 7, marginBottom: 7 }}>
                <div class="cs-order-popup">
                    {this.state.showPopup ? <PopUpItem closePopup={this.togglePopup.bind(this)} Get_PopUpItem={this.Get_PopUpItem} AlertPopup={this.props.AlertPopup} /> : null}
                </div>
                <ReactDataGrid
                    ref={input => this.grid = input}
                    enableCellSelect={true}
                    enableRowSelect={true}
                    columns={this.getColumns()}
                    rowGetter={this.getRowAt}
                    rowsCount={this.getSize()}
                    onGridRowsUpdated={this.handleGridRowsUpdated}
                    rowHeight={26}
                    minHeight={this.props.HCenter}
                    minWidth={this.props.WContent}
                    onGridKeyDown={this.onKeyDown}
                    onGridKeyUp={this.onKeyUp}
                    rowSelection={{
                        showCheckbox: false,
                        selectBy: {
                            isSelectedKey: 'isSelected'
                        }
                    }
                    }
                    rowScrollTimeout={200}
                    onRowClick={this.onReturnData}
                    onCellSelected={this.onCellSelected}
                    getCellActions={this.getCellActions} />
            </div>
        );
    }
}